// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CtsGantryStartupEventFilterComponent } from '../cts-gantry-startup-event-filter/cts-gantry-startup-event-filter.component';
import { CtsGantryInitEvent } from '../../interfaces/cts-gantry-init-event';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';

@Component({
  standalone: true,
  imports: [TranslateModule, CtsGantryStartupEventFilterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-startup-actions',
  templateUrl: './cts-gantry-startup-actions.component.html',
  styleUrl: './cts-gantry-startup-actions.component.scss',
})
export class CtsGantryStartupActionsComponent {
  @Input({ required: true }) systemDetails!: SystemDetailsModel;
  @Input({ required: true }) buttonFn: () => void = () => {};
  @Input({ required: true }) events: CtsGantryInitEvent[] = [];
  @Input() buttonName: 'logs' | 'compare' = 'logs';
  @Input() selectedEvent: CtsGantryInitEvent | undefined = undefined;
  @Output() selectedEventChange = new EventEmitter<CtsGantryInitEvent>();

  private readonly version =
    this.translateService.instant('cts.gantry.version');

  public constructor(private readonly translateService: TranslateService) {}

  protected onSelectedEventChange(event: CtsGantryInitEvent): void {
    this.selectedEvent = event;
    this.selectedEventChange.emit(event);
  }

  protected onButtonClick(): void {
    this.buttonFn();
  }

  protected handleSoftwareVersion(): string {
    const sv = this.systemDetails.systemSoftwareVersion.split('-')[0];
    const result = this.selectedEvent?.softwareVersion ?? sv;
    return this.buttonName === 'compare' ? result : `${this.version} ${result}`;
  }
}
